import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
import {
  FiChevronUp,
  FiChevronDown,
  FiCalendar,
  FiUpload,
  FiEdit3,
} from "react-icons/fi";
function EditImpression() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isCaracteristiquesAccordionOpen, setIsCaracteristiquesAccordionOpen] =
    useState(true);
  const toggleCaracteristiquesAccordion = () => {
    setIsCaracteristiquesAccordionOpen(!isCaracteristiquesAccordionOpen);
  };
  const [isImpressionAccordionOpen, setIsImpressionAccordionOpen] =
    useState(true);
  const toggleImpressionAccordion = () => {
    setIsImpressionAccordionOpen(!isImpressionAccordionOpen);
  };
  const [isFiltresAccordionOpen, setIsFiltresAccordionOpen] = useState(true);
  const toggleFiltresAccordion = () => {
    setIsFiltresAccordionOpen(!isFiltresAccordionOpen);
  };
  const [isChampsImpressionAccordionOpen, setIsChampsImpressionAccordionOpen] =
    useState(true);
  const toggleChampsImpressionAccordion = () => {
    setIsChampsImpressionAccordionOpen(!isChampsImpressionAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [impressionData, setImpressionData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   publipostage *******************************/
  const [publipostageData, setPublipostageData] = useState({ data: [] });
  const [selectedPublipostage, setSelectedPublipostage] = useState("");
  const handlePublipostageChange = (e) => {
    setSelectedPublipostage(e);
  };
  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPublipostageData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: publipostageData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/impressions/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const impressionData = await response.json();
      setImpressionData(impressionData);
      setSelectedModele(
        impressionData?.detail_impression?.["Caractéristiques"]?.["Modèle"]
      );
      setSelectedDate(
        impressionData?.detail_impression?.["Caractéristiques"]?.["Date"]
      );
      setSelectedProduit(
        impressionData?.detail_impression?.["Filtres"]?.["Produit"]
      );
      setSelectedDateDeDebut(
        impressionData?.detail_impression?.["Filtres"]?.["Date de début"]
      );
      setSelectedDateDeFin(
        impressionData?.detail_impression?.["Filtres"]?.["Date de fin"]
      );
      setSelectedProduit(
        impressionData?.detail_impression?.["Filtres"]?.["Produit"]
      );
      setSelectedPme(impressionData?.detail_impression?.["Filtres"]?.["PME"]);
      setSelectedInvestissements(
        impressionData?.detail_impression?.["Filtres"]?.["Investissement"]
      );
      setSelectedNatureInvestissement(
        impressionData?.detail_impression?.["Filtres"]?.["Catégorie PME"]
      );
      setSelectedValide(
        impressionData?.detail_impression?.["Impression"]?.["Valide"]
      );
      setSelectedFichier(
        impressionData?.detail_impression?.["Impression"]?.["Fichier"]
      );
      setSelectedReservation(
        impressionData?.detail_impression?.["Filtres"]?.["Réservation"]
      );
      setSelectedChamps1(
        impressionData?.detail_impression?.["Champs d'impression"]?.["Champ 1"]
      );
      setSelectedChamps2(
        impressionData?.detail_impression?.["Champs d'impression"]?.["Champ 2"]
      );
      setSelectedChamps3(
        impressionData?.detail_impression?.["Champs d'impression"]?.["Champ 3"]
      );
      setSelectedChamps4(
        impressionData?.detail_impression?.["Champs d'impression"]?.["Champ 4"]
      );
      setSelectedChamps5(
        impressionData?.detail_impression?.["Champs d'impression"]?.["Champ 5"]
      );
      setSelectedChamps6(
        impressionData?.detail_impression?.["Champs d'impression"]?.["Champ 6"]
      );
    } catch (error) {
      console.error(error);
    }
  };
  /************************* Nature investissement *******************************/
  const [natureInvestissementData, setNatureInvestissementData] = useState({
    data: [],
  });
  const [selectedNatureInvestissement, setSelectedNatureInvestissement] =
    useState("");
  const handleNatureInvestissementChange = (e) => {
    setSelectedNatureInvestissement(e);
  };
  const getNatureInvest = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/impressions/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setNatureInvestissementData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderNatureInvestissementOptions = () => {
    return [
      {
        options: natureInvestissementData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END  *******************************/
  /*************************   Produits  *******************************/
  const [produitsData, setproduitsData] = useState({ data: [] });
  const [selectedProduit, setSelectedProduit] = useState("");
  const handleProduitChange = (e) => {
    setSelectedProduit(e);
  };
  const getProduit = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/produits`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setproduitsData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderProduitOptions = () => {
    return [
      {
        options: produitsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END produits *******************************/
  /************************* investissements  *******************************/
  const [selectedInvestissements, setSelectedInvestissements] = useState("");
  const [investissementsData, setInvestissementsData] = useState({ data: [] });
  const handleInvestissementChange = (e) => {
    setSelectedInvestissements(e);
  };

  const getInvestissements = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/investissements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((investissements) => {
          setInvestissementsData(investissements);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestissementOptions = () => {
    return [
      {
        options: investissementsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Réservation   *******************************/
  const [selectedReservation, setSelectedReservation] = useState("");
  const [reservationData, setReservationData] = useState({ data: [] });
  const handleReservationChange = (e) => {
    setSelectedReservation(e);
  };
  const getReservation = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/reservations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((reservation) => {
          setReservationData(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderReservationOptions = () => {
    return [
      {
        options: reservationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Reservation *******************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/impressions/show_fields?impression_id=${id}&publipostage_id=${selectedModele?.value}&produit_id=${selectedProduit?.value}&pme_id=${selectedPme?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   Modele *******************************/
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };

  /*************************   END Modele  *******************************/
  const [selectedChamps1, setSelectedChamps1] = useState("");
  const [selectedChamps2, setSelectedChamps2] = useState("");
  const [selectedChamps3, setSelectedChamps3] = useState("");
  const [selectedChamps4, setSelectedChamps4] = useState("");
  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");
  function getFieldValue(champNumber) {
    switch (champNumber) {
      case 1:
        return selectedChamps1;
      case 2:
        return selectedChamps2;
      case 3:
        return selectedChamps3;
      case 4:
        return selectedChamps4;
      case 5:
        return selectedChamps5;
      case 6:
        return selectedChamps6;
      default:
        return null;
    }
  }

  function handleFieldChange(champNumber, value) {
    switch (champNumber) {
      case 1:
        setSelectedChamps1(value);
        break;
      case 2:
        setSelectedChamps2(value);
        break;
      case 3:
        setSelectedChamps3(value);
        break;
      case 4:
        setSelectedChamps4(value);
        break;
      case 5:
        setSelectedChamps5(value);
        break;
      case 6:
        setSelectedChamps6(value);
        break;
      default:
        break;
    }
  }
  const handleChamps1Change = (e) => {
    setSelectedChamps1(e.target.value);
  };

  const handleChamps2Change = (e) => {
    setSelectedChamps2(e.target.value);
  };

  const handleChamps3Change = (e) => {
    setSelectedChamps3(e.target.value);
  };

  const handleChamps4Change = (e) => {
    setSelectedChamps4(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };

  /*************************   Date d'engagement et limite *******************************/
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateLimite, setSelectedDateLimite] = useState("");

  /*************************   END date d'engagement   *******************************/
  /*************************   Fichier  *******************************/
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  /************************* END Fichier   *******************************/

  /******************************* Date de début *******************************************/
  const [selectedDateDeDebut, setSelectedDateDeDebut] = useState("");

  /******************************* END date de début *******************************************/
  /******************************* date de fin *******************************************/
  const [selectedDateDeFin, setSelectedDateDeFin] = useState("");
  /******************************* Valide *******************************************/
  const [selectedValide, setSelectedValide] = useState("");
  const handleValideChange = (e) => {
    setSelectedValide(e);
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* END Valide *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  /******************************* END Mode de règlement *******************************************/
  /******************************* IBAN *******************************************/
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  /******************************* END IBAN *******************************************/
  /******************************* BIC *******************************************/
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /******************************* END BIC *******************************************/
  /******************************* RUM *******************************************/
  const [selectedRum, setSelectedRum] = useState("");
  const handleRumChange = (e) => {
    setSelectedRum(e.target.value);
  };
  /******************************* END RUM *******************************************/

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("id", id);
      formData.append("date", selectedDate);
      formData.append("publipostage_id", selectedModele?.value || "");
      formData.append("date_de_debut", selectedDateDeDebut);
      formData.append("date_de_fin", selectedDateDeFin);
      formData.append("champ_1", selectedChamps1);
      formData.append("champ_2", selectedChamps2);
      formData.append("champ_3", selectedChamps3);
      formData.append("champ_4", selectedChamps4);
      formData.append("champ_5", selectedChamps5);
      formData.append("champ_6", selectedChamps6);
      formData.append("valide", selectedValide);
      formData.append("fichier", selectedFichier);
      formData.append(
        "natures_investissments",
        selectedNatureInvestissement?.value
      );
      formData.append("pme_id", selectedPme?.value || "");
      formData.append(
        "investissement_id",
        selectedInvestissements?.value || ""
      );
      formData.append("produit_id", selectedProduit?.value || "");
      formData.append("reservation_id", selectedReservation?.value || "");
      const response = await fetch(
        `https://www.fluxod.com/${api}/impressions/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.impression_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.impression_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (!loading) {
      getPublipostage();
      getNatureInvest();
      getPme();
      getProduit();
      getReservation();
      getInvestissements();
      getShow();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [loading, selectedModele, selectedProduit, selectedPme]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Impression | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails impression
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/impressions/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Impressions
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          impressionData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {impressionData?.detail_impression
                                  ?.Caractéristiques ? (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleCaracteristiquesAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Caractéristiques
                                        </span>
                                      </div>
                                      {isCaracteristiquesAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isCaracteristiquesAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            impressionData?.detail_impression
                                              ?.Caractéristiques || {}
                                          ).map(([key, value], index) => (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: [
                                                  "Modèle",
                                                  "Date",
                                                ].includes(key)
                                                  ? "white"
                                                  : "white",
                                                transition: "all 0.15s ease",
                                                borderLeft: "3px solid #dc3545",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                const isInvalid =
                                                  key === "Modèle" ||
                                                  key === "Date";

                                                if (isInvalid) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                const isInvalid =
                                                  key === "Modèle" ||
                                                  key === "Date";

                                                if (isInvalid) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }
                                              }}
                                            >
                                              {key === "Modèle" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedModele?.label ==
                                                        null
                                                          ? null
                                                          : selectedModele
                                                      }
                                                      onChange={
                                                        handleModeleChange
                                                      }
                                                      options={renderPublipostageOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedModele === null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                    {selectedModele ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Modèle ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key === "Date" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={selectedDate}
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      onChange={(
                                                        dateString
                                                      ) => {
                                                        setSelectedDate(
                                                          dateString.target
                                                            .value
                                                        );
                                                      }}
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiCalendar
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedDate === "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Date ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : null}
                                            </div>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : null}
                                {impressionData?.detail_impression
                                  ?.Impression ? (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleImpressionAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Impression
                                        </span>
                                      </div>
                                      {isImpressionAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isImpressionAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            impressionData?.detail_impression
                                              ?.Impression || {}
                                          ).map(([key, value], index) => (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              {key === "Valide" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="d-flex align-items-center">
                                                      <Switch
                                                        uncheckedIcon={
                                                          <Offsymbol />
                                                        }
                                                        checkedIcon={
                                                          <OnSymbol />
                                                        }
                                                        onColor="#555B21"
                                                        onChange={() => {
                                                          setSelectedValide(
                                                            !selectedValide
                                                          );
                                                        }}
                                                        checked={
                                                          selectedValide == 1
                                                            ? true
                                                            : false
                                                        }
                                                        height={24}
                                                        width={48}
                                                        handleDiameter={20}
                                                      />
                                                      <span
                                                        className="ms-2 small text-muted"
                                                        style={{
                                                          fontSize: "0.75rem",
                                                        }}
                                                      ></span>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              ) : key === "Fichier" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    {selectedFichier !=
                                                      null && (
                                                      <a
                                                        href={selectedFichier}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="d-block mb-2 small text-primary"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                        }}
                                                      >
                                                        <i className="bx bx-file me-1"></i>
                                                        Voir le fichier
                                                      </a>
                                                    )}
                                                    <div className="position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        type="file"
                                                        required
                                                        onChange={
                                                          handleFichierChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiUpload
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              ) : null}
                                            </div>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                <Col>
                                  {impressionData?.detail_impression?.[
                                    "Filtres"
                                  ] ? (
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleFiltresAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Filtres
                                          </span>
                                        </div>
                                        {isFiltresAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse isOpen={isFiltresAccordionOpen}>
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {Object.entries(
                                              impressionData
                                                ?.detail_impression?.[
                                                "Filtres"
                                              ] || {}
                                            ).map(([key], index) => (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                {key == "PME" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedPme?.label ==
                                                          null
                                                            ? null
                                                            : selectedPme
                                                        }
                                                        onChange={
                                                          handlePmeChange
                                                        }
                                                        options={renderPmeOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : key == "Investissement" &&
                                                  showField?.displayed_fields?.includes(
                                                    "investissement_id"
                                                  ) ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedInvestissements?.label ==
                                                          null
                                                            ? null
                                                            : selectedInvestissements
                                                        }
                                                        onChange={
                                                          handleInvestissementChange
                                                        }
                                                        options={renderInvestissementOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : key === "Réservation" &&
                                                  showField?.displayed_fields?.includes(
                                                    "reservation_id"
                                                  ) ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedReservation?.label ==
                                                          null
                                                            ? null
                                                            : selectedReservation
                                                        }
                                                        onChange={
                                                          handleReservationChange
                                                        }
                                                        options={renderReservationOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : key == "Catégorie PME" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedNatureInvestissement?.label ==
                                                          null
                                                            ? null
                                                            : selectedNatureInvestissement
                                                        }
                                                        onChange={
                                                          handleNatureInvestissementChange
                                                        }
                                                        options={renderNatureInvestissementOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : key == "Produit" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedProduit?.label ==
                                                          null
                                                            ? null
                                                            : selectedProduit
                                                        }
                                                        onChange={
                                                          handleProduitChange
                                                        }
                                                        options={renderProduitOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : key == "Date de début" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={8}
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={
                                                          selectedDateDeDebut
                                                        }
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={(
                                                          dateString
                                                        ) => {
                                                          setSelectedDateDeDebut(
                                                            dateString.target
                                                              .value
                                                          );
                                                        }}
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : key == "Date de fin" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={8}
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={
                                                          selectedDateDeFin
                                                        }
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={(
                                                          dateString
                                                        ) => {
                                                          setSelectedDateDeFin(
                                                            dateString.target
                                                              .value
                                                          );
                                                        }}
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : null}
                                              </div>
                                            ))}

                                            {/* Réservation conditionnelle */}
                                            {(!showField.displayed_fields ||
                                              !showField.displayed_fields.includes(
                                                "reservation_id"
                                              ) ||
                                              (showField.displayed_fields.includes(
                                                "reservation_id"
                                              ) &&
                                                (!impressionData ||
                                                  !impressionData.detail_impression ||
                                                  !impressionData
                                                    .detail_impression[
                                                    "Filtres"
                                                  ] ||
                                                  !Object.keys(
                                                    impressionData
                                                      .detail_impression[
                                                      "Filtres"
                                                    ]
                                                  ).includes(
                                                    "Réservation"
                                                  )))) && (
                                              <div
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Réservation
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedReservation?.label ==
                                                        null
                                                          ? null
                                                          : selectedReservation
                                                      }
                                                      onChange={
                                                        handleReservationChange
                                                      }
                                                      options={renderReservationOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  ) : null}
                                  {!Object.keys(
                                    impressionData.detail_impression
                                  ).includes("Champs d'impression") ? (
                                    <Col sm="12">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden mb-4"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En-tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={
                                            toggleChampsImpressionAccordion
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Champs d'impression
                                            </span>
                                          </div>
                                          {isChampsImpressionAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        <Collapse
                                          isOpen={
                                            isChampsImpressionAccordionOpen
                                          }
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {[1, 2, 3, 4, 5, 6].map(
                                                (champNumber) =>
                                                  showField.displayed_fields &&
                                                  showField.displayed_fields.includes(
                                                    `champ_${champNumber}`
                                                  ) &&
                                                  (!impressionData ||
                                                    !impressionData.detail_impression ||
                                                    !impressionData
                                                      .detail_impression[
                                                      "Champs d'impression"
                                                    ] ||
                                                    !Object.keys(
                                                      impressionData
                                                        .detail_impression[
                                                        "Champs d'impression"
                                                      ]
                                                    ).includes(
                                                      `Champ ${champNumber}`
                                                    )) ? (
                                                    <div
                                                      key={`champ_${champNumber}`}
                                                      className="field-item px-2 py-1 mb-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",

                                                        position: "relative",
                                                        marginBottom: "1px",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Champ{" "}
                                                              {champNumber}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            value={getFieldValue(
                                                              champNumber
                                                            )}
                                                            onChange={(e) =>
                                                              handleFieldChange(
                                                                champNumber,
                                                                e
                                                              )
                                                            }
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  ) : null
                                              )}
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>
                                  ) : null}

                                  <Col sm="12">
                                    {impressionData?.detail_impression?.[
                                      "Champs d'impression"
                                    ] ? (
                                      <>
                                        <Row>
                                          <Col sm="12">
                                            <Card
                                              className="shadow-sm border-0 overflow-hidden mb-4"
                                              style={{ borderRadius: "12px" }}
                                            >
                                              {/* En-tête cliquable */}
                                              <div
                                                className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                                style={{
                                                  background: "#555B21",
                                                  letterSpacing: "0.5px",
                                                  cursor: "pointer",
                                                  userSelect: "none",
                                                }}
                                                onClick={
                                                  toggleChampsImpressionAccordion
                                                }
                                              >
                                                <div className="d-flex align-items-center">
                                                  <span
                                                    style={{
                                                      fontSize: "0.82rem",
                                                    }}
                                                  >
                                                    Champs d'impression
                                                  </span>
                                                </div>
                                                {isChampsImpressionAccordionOpen ? (
                                                  <FiChevronUp size={16} />
                                                ) : (
                                                  <FiChevronDown size={16} />
                                                )}
                                              </div>

                                              <Collapse
                                                isOpen={
                                                  isChampsImpressionAccordionOpen
                                                }
                                              >
                                                <CardBody className="p-0">
                                                  <div
                                                    className="fields-container"
                                                    style={{
                                                      paddingBottom: "8px",
                                                    }}
                                                  >
                                                    {Object.entries(
                                                      impressionData
                                                        ?.detail_impression?.[
                                                        "Champs d'impression"
                                                      ] || {}
                                                    ).map(
                                                      ([key, value], index) => {
                                                        const champNumber =
                                                          key.split(" ")[1];
                                                        const fieldKey = `champ_${champNumber}`;
                                                        const shouldDisplay =
                                                          showField?.displayed_fields?.includes(
                                                            fieldKey
                                                          );

                                                        if (!shouldDisplay)
                                                          return null;

                                                        const champValue = {
                                                          "Champ 1":
                                                            selectedChamps1,
                                                          "Champ 2":
                                                            selectedChamps2,
                                                          "Champ 3":
                                                            selectedChamps3,
                                                          "Champ 4":
                                                            selectedChamps4,
                                                          "Champ 5":
                                                            selectedChamps5,
                                                          "Champ 6":
                                                            selectedChamps6,
                                                        }[key];

                                                        const isInvalid =
                                                          (key === "Champ 1" ||
                                                            key ===
                                                              "Champ 2") &&
                                                          champValue === "";

                                                        return (
                                                          <div
                                                            key={index}
                                                            className="field-item px-2 py-1 mb-1"
                                                            style={{
                                                              backgroundColor:
                                                                "white",
                                                              transition:
                                                                "all 0.15s ease",
                                                              borderLeft:
                                                                isInvalid
                                                                  ? "3px solid #dc3545"
                                                                  : "3px solid transparent",
                                                              borderRadius:
                                                                "6px",
                                                              position:
                                                                "relative",
                                                              marginBottom:
                                                                "1px",
                                                            }}
                                                            onMouseEnter={(
                                                              e
                                                            ) => {
                                                              if (isInvalid) {
                                                                e.currentTarget.style.backgroundColor =
                                                                  "#ffe6e6";
                                                                e.currentTarget.style.borderLeftColor =
                                                                  "#dc3545";
                                                              } else {
                                                                e.currentTarget.style.backgroundColor =
                                                                  "#e3f2fd";
                                                                e.currentTarget.style.borderLeftColor =
                                                                  "#007bff";
                                                              }
                                                            }}
                                                            onMouseLeave={(
                                                              e
                                                            ) => {
                                                              if (isInvalid) {
                                                                e.currentTarget.style.backgroundColor =
                                                                  "white";
                                                                e.currentTarget.style.borderLeftColor =
                                                                  "#dc3545";
                                                              } else {
                                                                e.currentTarget.style.backgroundColor =
                                                                  "white";
                                                                e.currentTarget.style.borderLeftColor =
                                                                  "transparent";
                                                              }
                                                            }}
                                                          >
                                                            <Row className="align-items-center g-1">
                                                              <Col
                                                                xs={12}
                                                                md={4}
                                                              >
                                                                <div className="d-flex align-items-center small text-muted">
                                                                  <span
                                                                    className="fw-medium"
                                                                    style={{
                                                                      fontSize:
                                                                        "0.8rem",
                                                                      letterSpacing:
                                                                        "0.2px",
                                                                    }}
                                                                  >
                                                                    {key}
                                                                  </span>
                                                                  {isInvalid && (
                                                                    <span className="ms-1">
                                                                      :
                                                                    </span>
                                                                  )}
                                                                  {!isInvalid && (
                                                                    <span className="ms-1 text-primary">
                                                                      :
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              </Col>
                                                              <Col
                                                                xs={12}
                                                                md={8}
                                                                style={{
                                                                  position:
                                                                    "relative",
                                                                }}
                                                              >
                                                                <input
                                                                  className="form-control form-control-sm shadow-sm border-0"
                                                                  value={
                                                                    champValue
                                                                  }
                                                                  required
                                                                  onChange={
                                                                    key ===
                                                                    "Champ 1"
                                                                      ? handleChamps1Change
                                                                      : key ===
                                                                        "Champ 2"
                                                                      ? handleChamps2Change
                                                                      : key ===
                                                                        "Champ 3"
                                                                      ? handleChamps3Change
                                                                      : key ===
                                                                        "Champ 4"
                                                                      ? handleChamps4Change
                                                                      : key ===
                                                                        "Champ 5"
                                                                      ? handleChamps5Change
                                                                      : handleChamps6Change
                                                                  }
                                                                  style={{
                                                                    fontSize:
                                                                      "0.8rem",
                                                                    backgroundColor:
                                                                      "#f8f9fa",
                                                                    borderRadius:
                                                                      "6px",
                                                                    padding:
                                                                      "0.375rem 0.75rem",
                                                                    height:
                                                                      "32px",
                                                                  }}
                                                                />
                                                                <FiEdit3
                                                                  size={12}
                                                                  className="position-absolute text-muted"
                                                                  style={{
                                                                    right:
                                                                      "8px",
                                                                    top: "50%",
                                                                    transform:
                                                                      "translateY(-50%)",
                                                                    pointerEvents:
                                                                      "none",
                                                                    opacity: 0.9,
                                                                  }}
                                                                />
                                                                {isInvalid && (
                                                                  <div className="invalid-feedback d-block mt-1 small">
                                                                    {key} ne
                                                                    peut pas
                                                                    être vide
                                                                  </div>
                                                                )}
                                                              </Col>
                                                            </Row>
                                                          </div>
                                                        );
                                                      }
                                                    )}

                                                    {/* Champ 6 conditionnel */}
                                                    {(!showField.displayed_fields ||
                                                      !showField.displayed_fields.includes(
                                                        "champ_6"
                                                      ) ||
                                                      (showField.displayed_fields.includes(
                                                        "champ_6"
                                                      ) &&
                                                        (!impressionData ||
                                                          !impressionData.detail_impression ||
                                                          !impressionData
                                                            .detail_impression[
                                                            "Champs d'impression"
                                                          ] ||
                                                          !Object.keys(
                                                            impressionData
                                                              .detail_impression[
                                                              "Champs d'impression"
                                                            ]
                                                          ).includes(
                                                            "Champ 6"
                                                          )))) && (
                                                      <div
                                                        className="field-item px-2 py-1 mb-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",

                                                          position: "relative",
                                                          marginBottom: "1px",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Champ 6
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={8}
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                selectedChamps6
                                                              }
                                                              required
                                                              onChange={
                                                                handleChamps6Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}
                                                  </div>
                                                </CardBody>
                                              </Collapse>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </>
                                    ) : null}
                                  </Col>
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditImpression;
